// import React from "react";
// import { Routes, Route } from "react-router-dom";
// import LobbyScreen from "./screens/Lobby";
// import RoomPage from "./screens/room";
// import ProtectedRoute from "./service/ProtectedRoute";

// function App() {
//     return (
//         <Routes>
//             <Route path="/" element={<LobbyScreen />} />
//             <Route
//                 path="/room/:roomId"
//                 element={
//                     <ProtectedRoute>
//                         <RoomPage />
//                     </ProtectedRoute>
//                 }
//             />
//         </Routes>
//     );
// }

// export default App;

import React from "react";
import { Routes, Route } from "react-router-dom";
import LobbyScreen from "./screens/Lobby";
import RoomPage from "./screens/room";
import AppointmentJoin from "./screens/AppointmentJoin";
import ProtectedRoute from "./service/ProtectedRoute";

function App() {
    return (
        <Routes>
            <Route path="/" element={<LobbyScreen />} />
            <Route path="/join" element={<AppointmentJoin />} />
            <Route
                path="/room/:roomId"
                element={
                    <ProtectedRoute>
                        <RoomPage />
                    </ProtectedRoute>
                }
            />
        </Routes>
    );
}

export default App;